import ManageRetire from '../../../views/Personnel/Letter/ManageRetire.letter.view';

export default ManageRetire;
